// Test script to verify login and token storage functionality
// Run this in the browser console after attempting to login

export const testLoginStorage = {
  // Test 1: Check if token and user are properly stored
  testStorageAfterLogin: function() {
    
    const localToken = localStorage.getItem('token');
    const sessionToken = sessionStorage.getItem('token');
    const localUser = localStorage.getItem('user');
    const sessionUser = sessionStorage.getItem('user');
    const rememberMe = localStorage.getItem('rememberMe');
    
    
    if (rememberMe === 'true') {
      if (localToken && localUser) {
      } else {
      }
    } else {
      if (sessionToken && sessionUser) {
      } else {
      }
    }
  },

  // Test 2: Simulate login with Remember Me ON
  testRememberMeOn: async function() {
    
    // Clear all storage first
    localStorage.clear();
    sessionStorage.clear();
    
    // Import the enhanced token manager
    const { enhancedTokenManager } = await import('./enhancedTokenManager');
    
    // Simulate storing token and user with Remember Me ON
    const testToken = 'test-token-remember-me-on';
    const testUser = { userId: 1, name: 'Test User', buildingId: 123 };
    
    enhancedTokenManager.setToken(testToken, true); // Remember Me = true
    enhancedTokenManager.setUserData(testUser, true);
    
    // Check results
    const localToken = localStorage.getItem('token');
    const localUser = localStorage.getItem('user');
    const sessionToken = sessionStorage.getItem('token');
    const sessionUser = sessionStorage.getItem('user');
    
    if (localToken === testToken && localUser && !sessionToken && !sessionUser) {
    } else {
    }
  },

  // Test 3: Simulate login with Remember Me OFF
  testRememberMeOff: async function() {
    
    // Clear all storage first
    localStorage.clear();
    sessionStorage.clear();
    
    // Import the enhanced token manager
    const { enhancedTokenManager } = await import('./enhancedTokenManager');
    
    // Simulate storing token and user with Remember Me OFF
    const testToken = 'test-token-remember-me-off';
    const testUser = { userId: 2, name: 'Test User 2', buildingId: 456 };
    
    enhancedTokenManager.setToken(testToken, false); // Remember Me = false
    enhancedTokenManager.setUserData(testUser, false);
    
    // Check results
    const localToken = localStorage.getItem('token');
    const localUser = localStorage.getItem('user');
    const sessionToken = sessionStorage.getItem('token');
    const sessionUser = sessionStorage.getItem('user');
    
    if (sessionToken === testToken && sessionUser && !localToken && !localUser) {
    } else {
    }
  },

  // Test 4: Test getUserData utility
  testGetUserData: async function() {
    
    const { getUserData } = await import('./getUserData');
    
    // Test with localStorage
    localStorage.setItem('user', JSON.stringify({ test: 'localStorage' }));
    sessionStorage.removeItem('user');
    let userData = getUserData();
    
    // Test with sessionStorage
    localStorage.removeItem('user');
    sessionStorage.setItem('user', JSON.stringify({ test: 'sessionStorage' }));
    userData = getUserData();
    
    // Clean up
    localStorage.removeItem('user');
    sessionStorage.removeItem('user');
  },

  // Run all tests
  runAllTests: async function() {
    
    this.testStorageAfterLogin();
    
    await this.testRememberMeOn();
    
    await this.testRememberMeOff();
    
    await this.testGetUserData();
    
  }
};

// Auto-expose to window for easy console access
if (typeof window !== 'undefined') {
  window.testLoginStorage = testLoginStorage;
}